import EditPage from "../../components/EditPage";
import PageHeaderEdit from "../../components/PageHeaderEdit";
import PageInfoEdit from "../../components/PageInfoEdit";
import { UploadFolderIdProvider } from "../../util/UploadFolderIdContext";

export default function Kristendomskursus() {
    const uploadFolderId = '13gHPsZzfoHdXjNWvnbXItg10WUoEkyIC';
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/Kristendomskursus">
                <PageHeaderEdit sectionKey="PageHeader" />
                <PageInfoEdit sectionKey="Sec1" />
                <PageInfoEdit sectionKey="Sec2" />
                <PageInfoEdit sectionKey="u4" />
            </EditPage>
        </UploadFolderIdProvider>
    );
}